import React from 'react';
import PrimaryUpcomingWebinar from './primaryUpcomingWebinar';
import SecondaryUpcomingWebinar from './secondaryUpcomingWebinar';
import './styles';
import BravelyData from 'utils/data';

const [firstUpcomingWebinar = {}, secondUpcomingWebinar = {}] =
  BravelyData('upcomingWebinars') || [];

const UpcomingWebinars = () =>
  Object.keys(firstUpcomingWebinar).length > 0 && (
    <div className="upcoming-webinar-wrapper employee-dashboard">
      <PrimaryUpcomingWebinar upcomingWebinar={firstUpcomingWebinar} />
      <div className="other-event">
        {Object.keys(secondUpcomingWebinar).length > 0 && (
          <SecondaryUpcomingWebinar upcomingWebinar={secondUpcomingWebinar} />
        )}
      </div>
    </div>
  );

export default UpcomingWebinars;
